/* PerfumeOffs: open header dropdown menus on hover (desktop only) */
(function () {
  var mq = window.matchMedia('(min-width: 990px)');

  function bind() {
    document.querySelectorAll('.header__inline-menu header-menu').forEach(function (menu) {
      var details = menu.querySelector('details');
      if (!details || details.dataset.poHover) return;
      details.dataset.poHover = '1';
      var summary = details.querySelector('summary');
      var closeTimer;

      function open() {
        clearTimeout(closeTimer);
        if (details.hasAttribute('open')) return;
        details.setAttribute('open', '');
        if (summary) summary.setAttribute('aria-expanded', 'true');
      }

      function close() {
        details.removeAttribute('open');
        if (summary) summary.setAttribute('aria-expanded', 'false');
      }

      menu.addEventListener('mouseenter', function () {
        if (!mq.matches) return;
        open();
      });

      menu.addEventListener('mouseleave', function () {
        if (!mq.matches) return;
        closeTimer = setTimeout(close, 150);
      });
    });
  }

  if (document.readyState !== 'loading') {
    bind();
  } else {
    document.addEventListener('DOMContentLoaded', bind);
  }
})();

(() => {
  const initWalletSubmenus = () => {
    const root = document.getElementById('HeaderMenu-wallet-and-bags')?.closest('details');
    if (!root || root.dataset.phWalletSubmenus) return;
    root.dataset.phWalletSubmenus = 'ready';
    const desktop = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
    const menus = Array.from(root.querySelectorAll('details'));
    const close = (menu) => {
      menu.open = false;
      menu.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
    };
    menus.forEach((menu) => {
      const summary = menu.querySelector(':scope > summary');
      let timer;
      const open = () => {
        window.clearTimeout(timer);
        menus.forEach((other) => {
          if (other !== menu && !other.contains(menu)) close(other);
        });
        menu.open = true;
        summary?.setAttribute('aria-expanded', 'true');
      };
      const scheduleClose = () => {
        window.clearTimeout(timer);
        timer = window.setTimeout(() => {
          if (!menu.matches(':hover') && !menu.contains(document.activeElement)) close(menu);
        }, 200);
      };
      menu.addEventListener('pointerenter', (event) => {
        if (desktop.matches && event.pointerType !== 'touch') open();
      });
      menu.addEventListener('pointerleave', (event) => {
        if (desktop.matches && event.pointerType !== 'touch') scheduleClose();
      });
      menu.addEventListener('focusout', scheduleClose);
      menu.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        event.preventDefault();
        event.stopPropagation();
        window.clearTimeout(timer);
        close(menu);
        summary?.focus();
      });
      menu.addEventListener('toggle', () => {
        summary?.setAttribute('aria-expanded', String(menu.open));
      });
      desktop.addEventListener('change', () => {
        window.clearTimeout(timer);
        if (!desktop.matches) close(menu);
      });
    });
    root.addEventListener('toggle', () => {
      if (!root.open) menus.forEach(close);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initWalletSubmenus);
  else initWalletSubmenus();
  document.addEventListener('shopify:section:load', initWalletSubmenus);
})();
